<template >
  <div>

    <div v-role="'est'" class="formPosition">
      <template>
        <v-container class="grey lighten-5">

          <v-col>

            <div class="text-center">
              <v-card class="mx-auto">
                <v-img class="white--text align-end" height="200px"
                  src="https://cdn.vuetifyjs.com/images/cards/docks.jpg">
                  <v-card-title>Softlineangola - Contactos</v-card-title>
                </v-img>

                <v-row>
                  <v-col md="6"><v-card-title>Localização : </v-card-title></v-col>
                  <v-col md="6"><v-card-title>Telefone e Endereço electrônico : </v-card-title></v-col>

                </v-row>

                <v-card-text class="text--primary">
                  <v-row>
                    <v-col md="4"><Strong style="font-size:20px;">País: </Strong><span>Angola</span></v-col>
                    <v-col md="6"><Strong style="margin-left:115px;font-size:20px;">Telefone: </Strong><span>948 105
                        702</span></v-col>
                  </v-row>
                  <v-row>
                    <v-col md="4"><Strong style="margin-left:50px;font-size:20px;">Província :</Strong><span>
                        Luanda</span></v-col>
                    <v-col md="6"><Strong style="margin-left:190px;font-size:20px;">Email:
                      </Strong><span>contacto.softline@gmail.com</span></v-col>
                  </v-row>
                  <v-row>
                    <v-col md="5"><Strong style="margin-left:95px;font-size:20px;">Bairro :</Strong><span>Bairro Praia do
                        Bispo N°45 Ingombota</span></v-col>
                    <v-col md="5"><Strong style="margin-left:80px;font-size:18px;">WebSite:
                      </Strong><span>www.softlineangola.com</span></v-col>
                  </v-row>

                </v-card-text>

                <v-card-title>Referências Bancarias : </v-card-title>
                <v-card-text class="text--primary">
                  <v-row>
                    <v-col md="4"><Strong style="font-size:20px;">Banco : BAI</Strong></v-col>
                  </v-row>
                  <v-row>
                    <v-col md="4"><Strong style="margin-left:40px;font-size:18px;">Conta:
                      </Strong><span>8230207510001</span></v-col>
                  </v-row>
                  <v-row>
                    <v-col md="4" style="margin-left:90px;font-size:16px;"><Strong>IBAN:</Strong><span></span>AO06 0040
                      0000 8230 2075 1012 1</v-col>
                  </v-row>
                  <v-row>
                    <v-col md="4"
                      style="margin-left:10px;font-size:18px;"><Strong>NIF:</Strong><span></span>5417492760</v-col>
                  </v-row>
                </v-card-text>

              </v-card>
            </div>
          </v-col>

        </v-container>
      </template>
    </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
// const message = require('../config/messages')
export default {

  data: () => ({

  }),

  computed: {

    instituicaodescricao() {
      return ls.get('instituicaodescricao')
    },
    anolectivo() {
      return ls.get('anolectivo')
    },
    loggedUserName() {
      return ls.get('nomeUsuario')
    },
    role() {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }
  },

  created() {
    // this.GetUserLocation()
    //  this.LoginlogsInsert('longitude', 'latitude')
  },

  methods: {

    async GetUserLocation() {
      this.$getLocation()
        .then(coordinates => {
          let location = Object.values(coordinates)

          let valores = location.toString().split(',')
          let latitude = valores[0]
          let longitude = valores[1]

          this.LoginlogsInsert(longitude, latitude)
        })
    },

    async ObterDataTimeRemote() {
      var today = new Date()
      var day = today.getDate() + ''
      var month = (today.getMonth() + 1) + ''
      var year = today.getFullYear() + ''
      var hour = today.getHours() + ''
      var minutes = today.getMinutes() + ''
      var seconds = today.getSeconds() + ''

      day = checkZero(day)
      month = checkZero(month)
      year = checkZero(year)
      hour = checkZero(hour)
      minutes = checkZero(minutes)
      seconds = checkZero(seconds)

      return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds)

      function checkZero(data) {
        if (data.length === 1) {
          data = '0' + data
        }
        return data
      }
    },

    async LoginlogsInsert(longitude, latitude) {
      let dtt = await this.ObterDataTimeRemote()
      const params =
      {
        loginUpdate: 0,
        username: ls.get('idPessoa'),
        nome: ls.get('nomeUsuario'),
        datain: dtt,
        dataout: '',
        autor: ls.get('nomeUsuario'),
        loginpkCode: ls.get('uuid'),
        instituicao: ls.get('instituicaodescricao'),
        role: ls.get('role'),
        latitude: 'latitude',
        longitude: 'longitude'

      }

      // consumindo a API
      try {
        let msg = await axios
          .post('/InsertOrUpdateLoginLogs', params)
          .then(res => res.data)
      } catch (error) {

      }
    }
  }
}
</script>
